module.exports = __webpack_public_path__ + "static/media/spinWheel.989d830e.mp3";